module.exports = __webpack_public_path__ + "media/LGameplayGGJ.57c91fb0.mp4";